import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  ref: "modalRef",
  class: "modal-content neon"
}
const _hoisted_2 = { class: "search" }
const _hoisted_3 = { class: "search-wrapper" }
const _hoisted_4 = { class: "wrapper" }
const _hoisted_5 = { class: "footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_modal_header = _resolveComponent("app-modal-header")!
  const _component_app_loader = _resolveComponent("app-loader")!
  const _component_app_input = _resolveComponent("app-input")!
  const _component_app_palette_template_card = _resolveComponent("app-palette-template-card")!
  const _component_app_button = _resolveComponent("app-button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_app_modal_header, { onClose: _ctx.close }, null, 8, ["onClose"]),
      (_ctx.isLoading)
        ? (_openBlock(), _createBlock(_component_app_loader, { key: 0 }))
        : _createCommentVNode("", true),
      _createElementVNode("section", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_app_input, {
            modelValue: _ctx.search,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
            placeholder: "search",
            icon: ['fas', 'search'],
            "is-label": false
          }, null, 8, ["modelValue"])
        ])
      ]),
      _createElementVNode("section", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paletteTemplates, (palette) => {
          return (_openBlock(), _createBlock(_component_app_palette_template_card, {
            key: palette.id,
            card: palette,
            "is-selected": _ctx.selectedCard?.id === palette?.id,
            onSelected: _ctx.selected
          }, null, 8, ["card", "is-selected", "onSelected"]))
        }), 128))
      ]),
      _createElementVNode("footer", _hoisted_5, [
        _createElementVNode("div", {
          class: "btn",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.apply && _ctx.apply(...args)))
        }, [
          _createVNode(_component_app_button, {
            severity: "warning",
            title: "apply"
          })
        ])
      ])
    ], 512)
  ]))
}